import {
  Actor,
  Gender,
  GenderNeutralNames,
  getDefaultRandomInGameNameType,
  InGameNameMode,
} from "../../models/Actor";
import { GetNewGuid } from "../../helpers/GuidHelper";
import {
  getActorAvatarColor,
  getActorAvatarInitial,
} from "../../helpers/actorAvatar";
export class ActorHelper {
  private static getRandomInGameName() {
    return GenderNeutralNames[
      Math.floor(Math.random() * GenderNeutralNames.length)
    ];
  }

  private static getNextWorkingName(actors: Actor[]) {
    const existingNames = new Set(actors.map((actor) => actor.workingName));
    let index = 1;
    let candidate = `NPC ${index}`;

    while (existingNames.has(candidate)) {
      index += 1;
      candidate = `NPC ${index}`;
    }

    return candidate;
  }

  static GetNewRandomActor(actors: Actor[] = []): Actor {
    const workingName = this.getNextWorkingName(actors);
    const inGameName = this.getRandomInGameName();

    return {
      id: GetNewGuid(),
      workingName,
      inGameName,
      inGameNameMode: InGameNameMode.random,
      randomInGameNameType: getDefaultRandomInGameNameType(Gender.random),
      gender: Gender.random,
    };
  }

  static GetActorProfilePicture(actorId: string, allActors: Actor[]) {
    if (actorId === "player") {
      return (
        <div className="flex items-center justify-center font-medium bg-creator-primary w-9 h-9 text-interaction-text-inverted text-16 rounded-circle">
          P
        </div>
      );
    }

    const actor = allActors.find((a) => a.id === actorId);

    return (
      <div
        className={`flex items-center justify-center border-2 min-w-9 min-h-9 max-w-9 max-h-9 rounded-circle border-creator-primary font-medium text-14 ${getActorAvatarColor(actor)}`}
      >
        {getActorAvatarInitial(actor?.workingName)}
      </div>
    );
  }
}
